import "./templates-header.css";

import { Button } from "@tql/ui-components-react/tql/buttons";
import { arrowLeft } from "@tql/ui-components-react/untitled/icons";

import { ColumnChooser } from "~/shared/components/column-chooser/column-chooser.tsx";
import { CustomerSearch } from "~/shared/components/customer-search/customer-search.tsx";
import type { BoardColumn } from "~/shared/types/quote-board-types.ts";
import type { Customer } from "~/shared/types/quote-details-types";

type TemplatesHeaderProps = {
	selectedCustomer: Customer | undefined;
	onCustomerChange: (customer: Customer | null) => void;
	selectedTemplateItem: number | undefined;
	setSelectedTemplateItem: (id: number | undefined) => void;
	onSave?: () => void;
	onCancel?: () => void;
	isLoading?: boolean;
	columns?: BoardColumn[];
	onColumnToggle?: (column: BoardColumn) => void;
	onResetColumns?: () => void;
	isMobile?: boolean;
};

export const TemplatesHeader = ({
	selectedCustomer,
	onCustomerChange,
	selectedTemplateItem,
	setSelectedTemplateItem,
	onSave,
	onCancel,
	isLoading,
	columns,
	onColumnToggle,
	onResetColumns,
	isMobile = false,
}: TemplatesHeaderProps) => {
	return (
		<div className={"templates-header"}>
			{selectedTemplateItem ? (
				<Button
					onClick={() => {
						setSelectedTemplateItem(undefined);
					}}
					svgIcon={arrowLeft}
					variant={"tertiary"}
				/>
			) : null}

			<CustomerSearch
				disabled={false}
				onCustomerChange={onCustomerChange}
				selectedCustomer={selectedCustomer}
				wrapperStyle={{ width: isMobile ? "100%" : "300px" }}
			/>

			{!selectedTemplateItem && !isMobile && (
				<div className={"templates-column-chooser"}>
					<ColumnChooser
						secondary
						columns={columns ?? []}
						onColumnToggle={onColumnToggle ?? (() => {})}
						onResetColumns={onResetColumns}
					/>
				</div>
			)}
			{selectedTemplateItem ? (
				<div className={"templates-header-buttons"}>
					<Button disabled={isLoading} onClick={onSave} variant={"primary"}>
						Save
					</Button>
					<Button disabled={isLoading} onClick={onCancel}>
						Cancel
					</Button>
				</div>
			) : null}
		</div>
	);
};
